export default {
  view: {
    back: {
      title1: 'Ваша реєстрація обробляється.',
      title2: 'Ви отримаєте підтвердження через SMS',
      buttonTopup: 'Поповніть знову',
      buttonBack: 'Далі',
      loading: 'Зачекайте. Триває&nbsp;верифікація&nbsp;оплати...'
    }
  },
  component: {
    cookie: {
      text: 'Я погоджуюся на зберігання в моєму пристрої файлів cookies.',
      button: 'OK'
    },
    header: {
      title: 'Реєстрація карти SIM <span class="no-wrap">Plus</span>'
    },
    progress: {
      step1: 'Початкові дані',
      step2: 'Перевірка',
      step3: 'Реєстрація'
    },
    register: {
      loadingText: 'Завантаження даних...',
      labelPhone: 'Номер телефону',
      labelEmail: 'номер SIM-карти',
      buttonNext: 'Далі',
      title: '<strong>Крок 1</strong> - Введіть свій номер телефону та SIM-карту',
      placeholderEmail: 'введіть номер SIM-карти',
      rodoText: 'Адміністратором даних є Polkomtel sp. z o. o., ul. Конструкторська 4 у Варшаві. Дані оброблятимуться з метою реєстрації SIM-картки відповідно до ст. 6 розділ 1 лист c GDPR у зв’язку зі ст. 60б Закону про телекомунікації та з метою укладення договору про надання телекомунікаційних послуг, відповідно до ст. 6 розділ 1 лист b GDPR. У зв’язку з вибором моделі перевірки даних підставою для обробки даних є згода Autopay S.A. на отримання від банку ING, дані щодо моєї особи та передача цих даних Polkomtel sp. z .o. o. зареєструвати SIM-карту як постачальника телекомунікаційних послуг. Персональні дані можуть бути передані таким категоріям одержувачів: суб’єктам, що надають адміністратору послуги, необхідні для досягнення вищезазначених цілей, у тому числі IT-партнерам, суб’єктам, що надають технічну підтримку або обслуговування клієнтів. Ви маєте право на: відкликання згоди в будь-який час (що не впливає на законність обробки, яка мала місце до її відкликання), виправлення даних, доступ до даних, видалення, обмеження обробки, передачу. Ці запити можна подавати до вищезазначених адресу Polkomtel sp. z o. o., а також: телефоном до відділу обслуговування клієнтів (тел. 601102601), електронною поштою bok@plus.pl, письмово або усно в пункті продажу (обслуговування) або до призначений інспектор із захисту даних за такою адресою: <a href="mailto:iod@plus.pl">iod@plus.pl</a>, можливі скарги голові Управління захисту персональних даних. Детальна інформація про обробку даних і контактні дані Polkomtel sp. z o.o. та призначений ним інспектор із захисту даних доступні за адресою <a href="http://www.plus.pl/dane-osobowe" target="_blank">www.plus.pl/dane-osobowe</a> ( вкладка : «ІНФОРМАЦІЯ POLKOMTEL SP. Z O.O. ЩОДО ОБРОБКИ ПЕРСОНАЛЬНИХ ДАНИХ КЛІЄНТА/АБОНЕНТА КАРТКИ»).'
    },
    footer: {
      copyrights: '© {year} Polkomtel Sp. z o.o. Всі права захищені'
    }
  },
  buttons: {
    logIn: 'Увійдіть',
    register: 'Зареєструйтеся'
  },
  validation: {
    invalid: 'Недійсне поле',
    required: 'Обов\'язкове поле',
    operatorInvalid: 'Введіть номер Plus',
    simInvalid: 'Введіть дійсний номер SIM-карти',
    phoneInvalid: 'Недійсний номер телефону',
    registered: 'Цей номер уже зареєстрований',
    processError: 'Під час обробки даних сталася помилка!'
  },
  globalMessages: {
    userSessionTimeOut: 'З міркувань безпеки ви автоматично вийшли з системи. Увійдіть знову.'
  }
}
